module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"gis:map":"Карта","gis:map:Editor":"Редактирование","gis:map:Diagrams":"Диаграммы","gis:map:Styles":"Стилизация","gis:map:Filters":"Фильтры","gis:map:Heatmaps":"Тепловая карта","gis:book":"Справочник","gis:book:Editor":"Редактирование","gis:book:Filters":"Фильтры","gis:book:Columns Settings":"Настройка отображения столбцов"}}')
  delete Component.options._Ctor
}
